import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiParameterCollectionModule } from '@components/shared/ui-parameter-collection/ui-parameter-collection.module';
import { UiJsonFormatterModule } from '@components/ui-json-formatter/ui-json-formatter.module';
import { SharedModule } from '@modules/shared.module';
import { UiGridResetModule } from '@pages/generics/grid/grid-reset';
import { JobTriggersGridComponent } from '@pages/jobs/grids/job-triggers';
import { JobTriggerJobComponent } from '@pages/jobs/grids/job-triggers/job-trigger-job.component';
import { JobsPageComponent } from '@pages/jobs/jobs.page';
import { ProcessGridModule } from '@pages/process/grids';
import { JobTriggerQueueItemComponent } from '@pages/queues/job-trigger-detail';
import { JobTriggerTaskComponent } from '@pages/tasks/job-trigger-detail';
import { ProcessService } from '@services';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiDateFormatModule } from '@uipath/angular/directives/ui-dateformat';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';
import { UiPipeModule } from '@uipath/angular/pipes';

import {
    JobDetailsModalComponent,
    JobModalComponent,
} from './modals';

const MODALS = [
    JobModalComponent,
    JobDetailsModalComponent,
];

const COMPONENTS = [
    JobsPageComponent,
    JobTriggersGridComponent,
    JobTriggerTaskComponent,
    JobTriggerJobComponent,
    JobTriggerQueueItemComponent,
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        UiSuggestModule,
        ProcessGridModule,
        UiJsonFormatterModule,
        UiParameterCollectionModule,
        UiGridModule,
        UiGridResetModule,
        UiNgLetModule,
        UiDateFormatModule,
        UiPipeModule,
        UiSpinnerButtonModule,
        UiContentLoaderModule,
    ],
    declarations: [
        ...MODALS,
        ...COMPONENTS,
    ],
    entryComponents: [
        ...MODALS,
    ],
    providers: [
        ProcessService,
    ],
})
export class JobModule { }
